export default {
      id: "arrow-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#arrow-usage",
      toString: function () {
        return this.url;
      }
    }